import Vue from 'vue'
import Router from 'vue-router'
const index = () => import('@/pages/index')
const notFound = () => import('@/pages/NotFound')
const faq = () => import('@/pages/faq')
const agreement = () => import('@/pages/agreement')
Vue.use(Router)
export default new Router({
    linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [
        {
            path: 'index',
            name: 'index',
            component: index,
            alias: '/'
        },
        {
            path: '/faq',
            name: 'faq',
            component: faq
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: agreement
        },
        {
            path: '*',
            component: notFound
        }]
})



// WEBPACK FOOTER //
// ./src/client/router/index.js